import React from 'react';

const PublicLayout = ({ children }) => (
  <div className="min-h-screen bg-background flex flex-col">
    <main className="flex-1 flex items-center justify-center">
      {children}
    </main>
  </div>
);

export default PublicLayout;
